import {isNotNilOrEmpty} from 'ramda-adjunct';

const HTTPS_PREFIX = 'https://';

// Attachment URIs come from inbound (untrusted) email — only allow absolute https URLs so that
// javascript:, data:, vbscript:, file: and relative URLs are never turned into clickable links.
export function isSafeAttachmentUrl(uri: string): boolean {
  return isNotNilOrEmpty(uri) && uri.trim().toLowerCase().startsWith(HTTPS_PREFIX);
}
